import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["color"];
import React from 'react';
var Home = function Home(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.53954 1.07466C9.81038 0.86401 10.1896 0.86401 10.4605 1.07466L17.9605 6.90799C18.1431 7.05008 18.25 7.26856 18.25 7.50001V16.6667C18.25 17.3076 17.9954 17.9223 17.5422 18.3755C17.089 18.8287 16.4743 19.0833 15.8333 19.0833H4.16667C3.52573 19.0833 2.91104 18.8287 2.45783 18.3755C2.00461 17.9223 1.75 17.3076 1.75 16.6667V7.50001C1.75 7.26856 1.85685 7.05008 2.03954 6.90799L9.53954 1.07466ZM3.25 7.86682V16.6667C3.25 16.9098 3.34658 17.1429 3.51849 17.3149C3.69039 17.4868 3.92355 17.5833 4.16667 17.5833H15.8333C16.0764 17.5833 16.3096 17.4868 16.4815 17.3149C16.6534 17.1429 16.75 16.9098 16.75 16.6667V7.86682L10 2.61682L3.25 7.86682Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 10C6.75 9.58579 7.08579 9.25 7.5 9.25H12.5C12.9142 9.25 13.25 9.58579 13.25 10V18.3333C13.25 18.7475 12.9142 19.0833 12.5 19.0833C12.0858 19.0833 11.75 18.7475 11.75 18.3333V10.75H8.25V18.3333C8.25 18.7475 7.91421 19.0833 7.5 19.0833C7.08579 19.0833 6.75 18.7475 6.75 18.3333V10Z",
    fill: color
  }));
};
export default Home;